import L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.locatecontrol'
import {GeoSearchControl} from 'leaflet-geosearch'
import CustomProvider from "./Provider";

export default class Maps {

    constructor(ID, lng, lat, zoom, loader) {
        this.ID = ID
        this.lng = lng
        this.lat = lat
        this.map = new L.Map(ID, {
            center: new L.LatLng(this.lat, this.lng),
            zoom: zoom,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            gestureHandling: true
        })
        this.marker = ''
        this.layersFromCPT = L.featureGroup()
        this.cptLayers = []
        this.loader = loader
        this.filters = document.getElementById('filters-maps')
        this.keywordHasResult = 0
        this.mapParams = {
            cpt: 'events'
        }
        this.apiParams = {}
        this.cluster = L.markerClusterGroup()
    }

    /**************
     * Init the map and display it
     *
     ***************/
    get init() {
        // Init the map
        // Source : https://leaflet.github.io/Leaflet.draw/docs/examples/full.html

        let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            osmAttrib = '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            osm = L.tileLayer(osmUrl, {attribution: osmAttrib});
        osm.addTo(this.map)

        let satelliteView = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            {
                attribution: 'Source: Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
            }
        )

        let baseMaps = {
            "<img src='/wp-content/plugins/creasit-maps/assets/dist/front/images/osm.png' />": osm,
            "<img src='/wp-content/plugins/creasit-maps/assets/dist/front/images/satellite.png' />": satelliteView
        }

        L.control.layers(baseMaps, null, {position: 'bottomright'}).addTo(this.map);

        L.Icon.Default.prototype.options.iconUrl = 'creasit-marker.png'
        L.Icon.Default.prototype.options.iconSize = [30, 42]
        L.Icon.Default.prototype.options.iconRetinaUrl = ''

        L.control.zoom({
            position: 'bottomright',
            zoomInTitle: 'Zoomer',
            zoomOutTitle: 'Dézoomer'
        }).addTo(this.map)

        let provider = new CustomProvider()

        let searchControl = new GeoSearchControl({

            position: 'topright',
            style: 'button',
            showMarker: true,
            showPopup: false,
            popupFormat: ({query, result}) => '<div class="geo-search">' + result.label + '</div>',
            // popupFormat: ({result}) => `${result.label}`,
            // resultFormat: ({result}) => `${result.label}`,
            marker: {
                icon: L && L.Icon ? new L.Icon.Default() : undefined,
                draggable: false,
            },
            maxMarkers: 1,
            maxSuggestions: 5,
            retainZoomLevel: true,
            animateZoom: true,
            searchLabel: "Rechercher une adresse",
            notFoundMessage: "Aucun résultat à cette adresse",
            // messageHideDelay: 3000,
            zoomLevel: 30,
            classNames: {
                container: 'leaflet-bar leaflet-control leaflet-control-geosearch',
                button: 'leaflet-bar-part leaflet-bar-part-single',
                resetButton: 'reset',
                msgbox: 'leaflet-bar message',
                form: '',
                input: '',
            },
            // autoComplete: true,
            // autoCompleteDelay: 250,
            // autoClose: false,
            // keepResult: false,
            // updateMap: true,
            provider: provider,
        })

        //console.log(searchControl)

        this.map.addControl(searchControl)

        this.map.on('geosearch/showlocation', function (event) {
            this.flyToBounds(event.location.bounds, {
                padding: [100, 100]
            })
        })

        L.control.locate({
                position: 'topright',
                showPopup: false,
                markerClass: L.marker,
                keepCurrentZoomLevel: true,
                drawCircle: false,
                icon: 'fa fa-crosshairs',
                flyTo: true,
                strings: {
                    title: "Indiquer ma position",
                },
                locateOptions: {
                    maxZoom: 15
                },
            }
        ).addTo(this.map);

        this.map.addLayer(this.cluster);
    }

    /**************
     * Add markers on map, by selected terms
     ***************/
    addMarkers(termsID, keyword, id, cpt = '') {
        // Init the PostsQuery Class
        let Query = new PostsQuery()

        // Set the custom creasit api route
        Query._APIRoute = 'mapsView'

        // Get API endpoint (= url)
        let URL = Query.getURL(this.mapParams)

        URL += Query.apiParams(this.apiParams)

        // Display loader
        this.loader.classList.add('load')
        if (this.filters !== null) {
            this.filters.classList.add('load')
        }

        Query.fetchAPI(URL, 'GET').then(
            data => {
                this.resetCPTMarkers()

                if (data.length === 0) {
                    this.toggleNoResultClass(true)
                }

                if (!!cpt && data.length > 0) {
                    this.toggleNoResultClass(false)
                    this.searchByCPT(data)
                }

                // Remove loader when data sent
                this.loader.classList.remove('load')
                if (this.filters !== null) {
                    this.filters.classList.remove('load')
                }
            }
        ).catch(err => {
            // TODO handle error to send
            console.log(err)
        })
    }


    searchByCPT(data) {
        let i = 0
        data.forEach((elements) => {
            this.marker = new L.DivIcon({
                iconSize: [40, 57], // size of the icon
                iconAnchor: [23, 56],
                popupAnchor: [-3, -55],
                className: 'creasit-marker icon-' + this.mapParams.cpt + ' ' + elements.filtersClass
            })
            this.createMarker(elements, i, 'cpt')
            i++
        })

        this.map.flyToBounds(this.cluster, {
            padding: [100, 100]
        })
    }

    createMarker(elements, index, type) {
        elements.places.forEach((place) => {
            // Get marker coordinates
            const mapElements = JSON.parse(place.marker);

            // Construct marker popup with all infos (do another function to get these infos ?)
            let contentPopup = this.getMarkerContent(elements, place, this.mapParams.cpt)


            new L.GeoJSON(mapElements, {
                // Init marker points
                pointToLayer: (feature, latlng) => {
                    if (feature.properties.radius) {
                        return new L.Circle(latlng, feature.properties.radius, {color: elements.layer_color});
                    } else {
                        return new L.Marker(latlng, {
                            icon: this.marker,
                            draggable: false,
                        });
                    }
                },
                // Add it to termsLayers (to save them by terms) AND to layersFromTerms (to display it on map)
                onEachFeature: (feature, layer) => {
                    if (feature.geometry.type !== 'Point') {
                        layer.setStyle({
                            color: elements.layer_color
                        })
                    }
                    layer.bindPopup(contentPopup, {maxWidth: 399})
                    this.cluster.addLayer(layer)

                },
            })


        })
    }

    toggleNoResultClass(add = false) {
        let wrapper = document.getElementById(this.ID).closest('.wrapper_map')
        if (!add) {
            wrapper.classList.remove('no-result')
        } else {
            wrapper.classList.add('no-result')
        }
    }


    resetCPTMarkers() {
        this.cluster.clearLayers()
    }


    getMarkerContent(elements, place, cpt) {
        let contentPopup = '';
        contentPopup += '<div class="marker-popup cpt ' + this.mapParams.cpt + '">'

        if (cpt === 'events') {
            contentPopup += '<a href="' + elements.post_link + '" title="Consulter la page ' + elements.post_link + '(même onglet)">'
        }


        if (elements.terms.length > 0) {
            let termLabel = ''
            if (cpt !== 'customs') {
                termLabel = elements.terms[0].name
            } else {
                termLabel = elements.terms[0].replaceAll('_', ' ')
            }
            contentPopup += '<p class="marker-popup__category">' + termLabel + '</p>'
        }

        if (cpt === 'events') {
            let isSameDate = elements.startDate === elements.endDate
            let startDate = new Date(elements.startDate)
            let endDate = !isSameDate ? new Date(elements.endDate) : null

            contentPopup += '<div class="marker-popup__dates">'
            contentPopup += '<span class="startDate">' + startDate.getDate() + ' ' + startDate.toLocaleString('fr-FR', {month: 'short'}) + ' ' + startDate.getFullYear() + '</span>'
            if (!isSameDate) {
                contentPopup += '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M10.3109 7.31571C10.2123 7.41514 10.1341 7.53323 10.0808 7.66325C10.0275 7.79326 10 7.93263 10 8.07338C10 8.21414 10.0275 8.35351 10.0808 8.48352C10.1341 8.61353 10.2123 8.73163 10.3109 8.83105L14.4355 13.0009L10.3109 17.1708C10.1121 17.3718 10.0005 17.6443 10.0005 17.9285C10.0005 18.2127 10.1121 18.4852 10.3109 18.6862C10.5096 18.8871 10.7792 19 11.0603 19C11.3414 19 11.611 18.8871 11.8098 18.6862L16.6891 13.7532C16.7877 13.6538 16.8659 13.5357 16.9192 13.4057C16.9725 13.2757 17 13.1363 17 12.9956C17 12.8548 16.9725 12.7154 16.9192 12.5854C16.8659 12.4554 16.7877 12.3373 16.6891 12.2379L11.8098 7.30496C11.4058 6.89657 10.7255 6.89657 10.3109 7.31571Z" />\n' +
                    '</svg>'
                contentPopup += '<span class="endDate">' + endDate.getDate() + ' ' + endDate.toLocaleString('fr-FR', {month: 'short'}) + ' ' + endDate.getFullYear() + '</span>'
            }
            contentPopup += '</div>'
        }

        if (cpt === 'contacts' || cpt === 'customs') {
            contentPopup += '<a href="' + elements.post_link + '" title="Consulter la page ' + elements.post_link + '(même onglet)">'
        }

        contentPopup += '<h3 class="marker-popup__title">' + elements.post_title + '</h3>'

        if (cpt === 'contacts' || cpt === 'customs') {
            contentPopup += '</a>'
        }

        if (cpt === 'events') {
            contentPopup += '<div class="marker-popup__location-from">'
            contentPopup += '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M12.9993 5C9.66637 5 7.00003 7.6601 7.00003 10.9852C7.00003 16.0099 12.3327 20 12.9993 20C13.6659 20 18.9986 16.0099 18.9986 10.9852C19.0726 7.6601 16.3322 5 12.9993 5ZM12.9993 13.6453C11.518 13.6453 10.333 12.4631 10.333 10.9852C10.333 9.50739 11.518 8.32512 12.9993 8.32512C14.4806 8.32512 15.6656 9.58128 15.6656 10.9852C15.6656 12.3892 14.4806 13.6453 12.9993 13.6453Z"/>\n' +
                '</svg>'
            contentPopup += '<p class="marker-popup__location-title">' + elements.mapTitle + '</p>'
            contentPopup += '</div>'
        }

        if (cpt === 'contacts' || cpt === 'customs') {
            let mapElements = JSON.parse(place.marker)
            let hrefExport = ""
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                hrefExport = 'maps://maps.apple.com/?q=' + mapElements.geometry.coordinates[1] + ',' + mapElements.geometry.coordinates[0]
            } else if (/Android/i.test(navigator.userAgent)) {
                hrefExport = 'geo:' + mapElements.geometry.coordinates[0] + ',' + mapElements.geometry.coordinates[1]
            } else {
                hrefExport = 'https://www.openstreetmap.org/directions?to=' + mapElements.geometry.coordinates[1] + '%2C' + mapElements.geometry.coordinates[0] + '#map=17/' + mapElements.geometry.coordinates[1] + '/' + mapElements.geometry.coordinates[0]
            }

            if (elements.phone) {
                contentPopup += '<div class="marker-popup__phone">'
                contentPopup += '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M47.9806 40.322L43.1002 45.1632C42.3798 45.9021 41.4249 46.1523 40.4949 46.1535C36.3823 46.0303 32.4949 44.0101 29.3032 41.9357C24.0641 38.1243 19.257 33.3983 16.24 27.6871C15.0828 25.2922 13.7251 22.2365 13.8548 19.5633C13.8664 18.5578 14.1374 17.5709 14.8456 16.9227L19.7259 12.0448C20.7394 11.1828 21.7194 11.4808 22.3679 12.4849L26.2942 19.9301C26.7075 20.8122 26.4704 21.7572 25.8538 22.3875L24.0558 24.1846C23.9448 24.3366 23.8741 24.5097 23.8723 24.6981C24.5618 27.367 26.6506 29.8269 28.4958 31.5198C30.341 33.2127 32.3244 35.5063 34.899 36.0492C35.2172 36.138 35.607 36.1692 35.8347 35.9575L37.9264 33.8303C38.6474 33.2838 39.6885 33.0167 40.4582 33.4636H40.4949L47.5769 37.6446C48.6166 38.2963 48.725 39.5558 47.9806 40.322Z"/>\n' +
                    '</svg>'
                contentPopup += '<a href="tel:' + elements.phoneLink + '" title="Contacter le ' + elements.phone + '"> ' + elements.phoneLabel + '</a>'
                contentPopup += '</div>'
            }

            if (elements.mail) {
                contentPopup += '<div class="marker-popup__mail">'
                contentPopup += '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M21 17.0001V8.42863C21 7.63816 20.3698 7.00006 19.5891 7.00006H6.41093C5.63022 7.00006 5 7.63816 5 8.42863V17.0001C5 17.7905 5.63022 18.4286 6.41093 18.4286H19.5891C20.3698 18.4286 21 17.7905 21 17.0001ZM19.7678 8.32387C20.0782 8.63816 19.9089 8.96197 19.7396 9.12387L15.9206 12.6667L19.5891 16.5334C19.7019 16.6667 19.7772 16.8763 19.6455 17.0191C19.5232 17.1715 19.241 17.162 19.1188 17.0667L15.0082 13.5143L12.9953 15.3715L10.9918 13.5143L6.88125 17.0667C6.75897 17.162 6.47678 17.1715 6.3545 17.0191C6.22281 16.8763 6.29806 16.6667 6.41093 16.5334L10.0794 12.6667L6.26043 9.12387C6.09112 8.96197 5.92181 8.63816 6.23222 8.32387C6.54262 8.00958 6.86243 8.16197 7.12581 8.39054L12.9953 13.1905L18.8742 8.39054C19.1376 8.16197 19.4574 8.00958 19.7678 8.32387Z"/>\n' +
                    '</svg>'
                contentPopup += '<a href="mailto:' + elements.mail + '" title="Contacter ' + elements.mail + '"> ' + elements.mail + '</a>'
                contentPopup += '</div>'
            }

            if (place.address_group.address || place.address_group.additional_address || place.address_group.zip_code || place.address_group.city) {
                contentPopup += '<div class="marker-popup__group-address">'
                contentPopup += '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M12.9993 5C9.66637 5 7.00003 7.6601 7.00003 10.9852C7.00003 16.0099 12.3327 20 12.9993 20C13.6659 20 18.9986 16.0099 18.9986 10.9852C19.0726 7.6601 16.3322 5 12.9993 5ZM12.9993 13.6453C11.518 13.6453 10.333 12.4631 10.333 10.9852C10.333 9.50739 11.518 8.32512 12.9993 8.32512C14.4806 8.32512 15.6656 9.58128 15.6656 10.9852C15.6656 12.3892 14.4806 13.6453 12.9993 13.6453Z"/>\n' +
                    '</svg>'
                contentPopup += '<div class="marker-popup__group-address__group">'
                contentPopup += '<p class="marker-popup__address">' + place.address_group.address + '</p>'
                contentPopup += '<p class="marker-popup__additional-address">' + place.address_group.additional_address + '</p>'
                contentPopup += '<p class="marker-popup__zipcity">' + place.address_group.zip_code + ' ' + place.address_group.city + '</p>'
                contentPopup += (mapElements.geometry.type === "Point" && !("radius" in mapElements.properties)) ? '<a href="' + hrefExport + '" title="Calculer un itinéraire" target="_blank" class="marker-popup__itinerary"><span>Calculer un itinéraire</span></a>' : ""
                contentPopup += '</div>'
                contentPopup += '</div>'
            }
        }

        if (cpt === 'events') {
            contentPopup += '</a>'
        }

        contentPopup += '</div>'

        return contentPopup
    }
}
